var _mask, _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXmlsCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_25837)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1_25837",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 25.5C0 11.6929 11.1929 0.5 25 0.5C38.8071 0.5 50 11.6929 50 25.5C50 39.3071 38.8071 50.5 25 50.5C11.1929 50.5 0 39.3071 0 25.5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25.5C0 11.6929 11.1929 0.5 25 0.5C38.8071 0.5 50 11.6929 50 25.5C50 39.3071 38.8071 50.5 25 50.5C11.1929 50.5 0 39.3071 0 25.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3805 38.5001H16.6175C15.7242 38.5001 15 37.6685 15 36.6429V14.3571C15 13.3315 15.7242 12.5 16.6175 12.5H27.4988L34.998 21.1104V36.6429C34.998 37.6685 34.2737 38.5001 33.3805 38.5001Z",
    fill: "url(#paint0_linear_1_25837)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1_25837)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.544 25.416H18.457V32.5069H31.544V25.416Z",
    fill: "white",
    fillOpacity: 0.11
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_25837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9993 21.1104H33.1405C30.0253 21.1104 27.5 18.2109 27.5 14.6342V12.5L34.9993 21.1104Z",
    fill: "url(#paint1_linear_1_25837)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8751 26.4911C16.8732 26.3871 16.8916 26.2849 16.9275 26.2009C16.9704 26.1066 17.022 26.025 17.0803 25.9591C17.1685 25.881 17.2597 25.8131 17.3533 25.756L17.6263 25.5625L18.7184 24.7766C18.8702 24.6557 19.1531 24.4542 19.5671 24.1721L20.0863 23.8094L20.273 23.6957L20.3055 23.6715C20.3144 23.6683 20.3236 23.6683 20.3324 23.6715C20.3534 23.6557 20.376 23.6475 20.3989 23.6473C20.4428 23.6432 20.4866 23.6541 20.5279 23.6794C20.5692 23.7048 20.6071 23.744 20.6394 23.7948C20.6668 23.8389 20.6886 23.8922 20.7034 23.9512C20.7182 24.0103 20.7258 24.0739 20.7257 24.1382V24.7524C20.7243 24.8664 20.7037 24.9773 20.6663 25.0716C20.6269 25.1769 20.5682 25.2569 20.4994 25.2989L18.2685 26.8586L20.4994 28.4183C20.5658 28.4652 20.6235 28.5421 20.6663 28.6407C20.7052 28.7311 20.726 28.8405 20.7257 28.9527V29.5669C20.7257 29.6319 20.7181 29.6962 20.7033 29.756C20.6884 29.8158 20.6667 29.8699 20.6394 29.9151C20.6076 29.9675 20.5699 30.0081 20.5285 30.0343C20.4871 30.0605 20.443 30.0718 20.3989 30.0674C20.3762 30.067 20.3536 30.0597 20.3324 30.0457L20.273 30.0118L20.0863 29.8982L19.5714 29.5403L18.7226 28.9382L17.6305 28.1523L17.3575 27.9588C17.2698 27.8984 17.1779 27.8307 17.0845 27.7533C17.0266 27.7071 16.9769 27.6352 16.9409 27.545C16.9048 27.4548 16.8835 27.3497 16.8794 27.2407L16.8751 26.4911Z",
    fill: "white",
    fillOpacity: 0.38
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0453 30.0682C24.9603 30.0708 24.8763 30.0454 24.8017 29.9945C24.7272 29.9437 24.6648 29.8693 24.6208 29.7788C24.5843 29.7136 24.5552 29.6425 24.5342 29.5675L24.4782 29.3796L23.2557 26.0189L23.1674 25.7696C23.0656 25.4992 22.8686 24.9627 22.5766 24.16C22.1974 23.1391 22.0078 22.5793 22.0078 22.4807C22.0079 22.4213 22.0188 22.3627 22.0396 22.3093C22.0605 22.2559 22.0909 22.209 22.1284 22.1723C22.2131 22.0832 22.3214 22.0365 22.4323 22.0414H22.8296C22.9133 22.0396 22.9959 22.0654 23.0689 22.1162C23.142 22.1671 23.2029 22.2411 23.2455 22.3308L23.3338 22.542L23.3899 22.73L23.709 23.6045L24.6123 26.0907L24.7311 26.4075L25.2914 27.9389C25.5062 28.4883 25.6956 29.0525 25.8585 29.6288C25.8582 29.6879 25.8472 29.7461 25.8263 29.7991C25.8055 29.8521 25.7752 29.8986 25.7379 29.9351C25.6533 30.0244 25.5449 30.0711 25.434 30.0661L25.0453 30.0682Z",
    fill: "white",
    fillOpacity: 0.38
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4788 30.0672C27.4336 30.0722 27.3882 30.0613 27.3456 30.0351C27.3029 30.009 27.2639 29.9681 27.231 29.9152C27.1765 29.8232 27.1454 29.6984 27.1446 29.5677V28.955C27.1439 28.8437 27.1637 28.7349 27.2012 28.6437C27.2436 28.5425 27.3028 28.4652 27.3712 28.4218L29.6116 26.8656L27.3712 25.3119C27.3031 25.2612 27.2455 25.1772 27.2055 25.0707C27.1669 24.9792 27.1456 24.8697 27.1446 24.757V24.1346C27.1441 24.0709 27.1514 24.0078 27.166 23.9492C27.1807 23.8907 27.2023 23.8379 27.2295 23.7944C27.2961 23.6924 27.3837 23.6395 27.4731 23.6472C27.4938 23.6466 27.5143 23.6549 27.5326 23.6713C27.5448 23.6677 27.5572 23.6677 27.5694 23.6713L27.5992 23.6955C27.5907 23.6955 27.6501 23.7244 27.779 23.8088L28.3059 24.1708C28.2785 24.1498 28.5618 24.3509 29.1556 24.7739C29.4794 25.0007 29.8505 25.2693 30.2688 25.5797L30.375 25.6473L30.528 25.751C30.6182 25.8056 30.7052 25.8734 30.7884 25.9537C30.8479 25.9999 30.8989 26.0733 30.9354 26.1657C30.9719 26.2581 30.9925 26.3659 30.9952 26.4772V27.2251C30.9939 27.3277 30.9742 27.4271 30.9386 27.5098C30.899 27.6034 30.8478 27.6809 30.7884 27.7366C30.7078 27.8041 30.6129 27.8765 30.5052 27.9537L30.2221 28.1467L27.755 29.9055C27.6841 29.9658 27.6417 30.0044 27.6289 30.0189L27.602 30.0527L27.4788 30.0672Z",
    fill: "white",
    fillOpacity: 0.38
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0907 26.5156L20.8003 28.1527H20.8278L21.5408 26.5156H22.3809L21.3071 28.9173L22.4049 31.319H21.5494L20.8278 29.6796H20.8003L20.0787 31.319H19.2266L20.3278 28.9173L19.2472 26.5156H20.0907ZM23.1903 26.5156H24.1077L25.0767 29.7429H25.1179L26.0869 26.5156H27.0043V31.319H26.2828V28.1926H26.2536L25.343 31.2955H24.8516L23.9411 28.1809H23.9119V31.319H23.1903V26.5156ZM27.9559 31.319V26.5156H28.6998V30.4817H30.2082V31.319H27.9559Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5H50H0ZM50 50.5H0H50ZM0 50.5V0.5V50.5ZM26 0.5C39.8071 0.5 51 11.6929 51 25.5C51 39.3071 39.8071 50.5 26 50.5H25C38.2548 50.5 49 39.3071 49 25.5C49 11.6929 38.2548 0.5 25 0.5H26Z",
    fill: "white",
    mask: "url(#path-1-inside-1_1_25837)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_25837",
    x: -20.543,
    y: -13.584,
    width: 91.0859,
    height: 85.0918,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.5,
    result: "effect1_foregroundBlur_1_25837"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_25837",
    x: 4.5,
    y: -11.5,
    width: 57.5,
    height: 58.6113,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_25837"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_25837",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_25837",
    x1: 24.999,
    y1: 12.5,
    x2: 24.999,
    y2: 38.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C075EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2BBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_25837",
    x1: 31.2496,
    y1: 12.5,
    x2: 31.2496,
    y2: 21.1104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B051E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#702596"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_25837"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 25.5C0 11.6929 11.1929 0.5 25 0.5C38.8071 0.5 50 11.6929 50 25.5C50 39.3071 38.8071 50.5 25 50.5C11.1929 50.5 0 39.3071 0 25.5Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmlsCircle);
export default __webpack_public_path__ + "static/media/XmlsCircle.9a0b7f7210df4c2e0689ccf0e264f85b.svg";
export { ForwardRef as ReactComponent };